import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/session_notifications/${resource.id}/edit`} />,
    <MenuItem primaryText='Session' key='session' value={`/write-now/sessions/${resource.session_id}/edit`} />
  ]
}

export default buildMenuItems
